/**
 * Recursively builds FormData from an object,
 * compatible with ASP.NET Core model binding.
 *
 * Handles:
 * - Nested objects (creates keys like "From.Name")
 * - Arrays (creates keys like "ToRecipients[0].Address")
 * - File and File[] fields
 */
export function objectToFormData(model: unknown): FormData {
  const formData = new FormData();

  if (!model) return formData;

  Object.entries(model).forEach(([key, value]) => {
    if (value == null) return;

    // ✅ FIX 1: single File
    if (value instanceof File) {
      formData.append(key, value);
      return;
    }

    // Handle arrays
    if (Array.isArray(value)) {
      // array of files
      if (value.length && value[0] instanceof File) {
        value.forEach((file) => formData.append(key, file));
      }
      // array of objects
      else if (value.length && typeof value[0] === "object") {
        value.forEach((item, index) => {
          Object.entries(item).forEach(([childKey, childValue]) => {
            if (childValue != null) {
              formData.append(
                `${key}[${index}].${childKey}`,
                String(childValue)
              );
            }
          });
        });
      }
      // array of primitives
      else {
        value.forEach((v, index) =>
          formData.append(`${key}[${index}]`, String(v))
        );
      }
      return;
    }

    // Handle nested objects
    if (typeof value === "object") {
      Object.entries(value).forEach(([childKey, childValue]) => {
        if (childValue != null) {
          formData.append(`${key}.${childKey}`, String(childValue));
        }
      });
      return;
    }

    // primitives
    formData.append(key, String(value));
  });

  return formData;
}
